const types = {
    GET_LAB_PACKAGE: "GET_LAB_PACKAGE",
    GET_LAB_PACKAGE_SUCCESS: "GET_LAB_PACKAGE_SUCCESS",
}

export default types;